<template>
    <section class="component" style="position: relative">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.ui-element-settings.ui-settings')}}
            </span>
        </section>
        <section class="component__body settings">
            <section class="settings__item">
                <section class="column-item in-row">
                    <section class="esesja-modal__row">
                        <div class="form-bootstrap-check form-bootstrap-switch">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                                   id="menuInteractiveShowQorum_id"
                                   v-model="$store.state.settings.runtime.menuInteractiveShowQorum"
                                   @change="updateMenuInteractiveShowQorum()" />
                        </div>
                    </section>
                    <label class="esesja-modal__wraper__body__label" for="menuInteractiveShowQorum_id">{{$t('com.file.ui-element-settings.show-quorum-menu')}}</label>
                </section>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="interactiveModalVotingShowAvatar_id"
                               v-model="$store.state.settings.runtime.interactiveModalVotingShowAvatar"
                               @change="updateInteractiveModalVotingShowAvatar()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="interactiveModalVotingShowAvatar_id">{{$t('com.file.ui-element-settings.show-avatars-voting')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="interactiveModalQuorumShowAvatar_id"
                               v-model="$store.state.settings.runtime.interactiveModalQuorumShowAvatar"
                               @change="updateInteractiveModalQuorumShowAvatar()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="interactiveModalQuorumShowAvatar_id">{{$t('com.file.ui-element-settings.show-avatars-quorum')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="interactiveDiscussionShowAvatar_id"
                               v-model="$store.state.settings.runtime.interactiveDiscussionShowAvatar"
                               @change="updateInteractiveDiscussionShowAvatar()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="interactiveDiscussionShowAvatar_id">{{$t('com.file.ui-element-settings.show-avatars-discussion')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="clientLogoShowOw_id"
                               v-model="$store.state.settings.runtime.clientLogoShowOw"
                               @change="updateClientLogoShowOw()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="clientLogoShowOw_id">{{$t('com.file.ui-element-settings.show-logo-ow')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="clientLogoShowDocuments_id"
                               v-model="$store.state.settings.runtime.clientLogoShowDocuments"
                               @change="updateClientLogoShowDocuments()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="clientLogoShowDocuments_id">{{$t('com.file.ui-element-settings.show-logo-docs')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="clientFooterShowDocuments_id"
                               v-model="$store.state.settings.runtime.clientFooterShowDocuments"
                               @change="updateClientFooterShowDocuments()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="clientFooterShowDocuments_id">{{$t('com.file.ui-element-settings.show-footer-docs')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showClockInOw_id"
                               v-model="$store.state.settings.runtime.showClockInOw"
                               @change="updateShowClockInOw()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showClockInOw_id">{{$t('com.file.ui-element-settings.show-clock-ow')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="userOnlineBasedOnMicrophones_id"
                               v-model="$store.state.settings.runtime.userOnlineBasedOnMicrophones"
                               @change="updateUserOnlineBasedOnMicrophones()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="userOnlineBasedOnMicrophones_id">{{$t('com.file.ui-element-settings.users-online-by-mic')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="supportCalendarIntegration_id"
                               v-model="$store.state.settings.runtime.supportCalendarIntegration"
                               @change="updateSupportCalendarIntegration()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="supportCalendarIntegration_id">{{$t('com.file.ui-element-settings.outside-calendar')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="displayGovernmentNews_id"
                               v-model="$store.state.settings.runtime.displayGovernmentNews"
                               @change="updateDisplayGovernmentNews()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="displayGovernmentNews_id">{{$t('com.file.ui-element-settings.show-news-in-main-pannel')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showUserAvatarInMultiSelect_id"
                               v-model="$store.state.settings.runtime.showUserAvatarInMultiSelect"
                               @change="updateShowUserAvatarInMultiSelect()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showUserAvatarInMultiSelect_id">{{$t('com.file.ui-element-settings.show-avatars-in-selects')}}</label>
            </section>

            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showUserAvatarInContacts_id"
                               v-model="$store.state.settings.runtime.showUserAvatarInContacts"
                               @change="updateShowUserAvatarInContacts()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showUserAvatarInContacts_id">{{$t('com.file.ui-element-settings.show-avatars-in-contacts')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showVotingListInOw_id"
                               v-model="$store.state.settings.runtime.showVotingListInOw"
                               @change="updateShowVotingListInOw()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showVotingListInOw_id">{{$t('com.file.ui-element-settings.show-voting-list-in-ow')}}</label>
            </section>
            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showNamedVotingResultsInOw_id"
                               v-model="$store.state.settings.client.showNamedVotingResultsInOw"
                               @change="updateShowNamedVotingResultsInOw()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showNamedVotingResultsInOw_id">{{$t('com.file.ui-element-settings.show-named-voting-results-in-ow')}}</label>
            </section>

            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="showSpeakerAboveAttachment_id"
                               v-model="$store.state.settings.client.showSpeakerAboveAttachment"
                               @change="updateShowSpeakerAboveAttachment()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="showSpeakerAboveAttachment_id">{{$t('com.file.ui-element-settings.show-speaker-above-attachment')}}</label>
            </section>

            <section class="column-item in-row">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                               id="hideDefaultFooterInEmail_id"
                               v-model="$store.state.settings.client.hideDefaultFooterInEmail"
                               @change="updateHideDefaultFooterInEmail()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="hideDefaultFooterInEmail_id">{{$t('com.file.ui-element-settings.hide-default-footer-in-email')}}</label>
            </section>

        </section>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
import settingsService from "../../../../../services/settings.service";
import SmallLoader from "../../../../BasicControls/SmallLoader.vue";
//import alertsHelper from "../../../../../helpers/alerts.helper";

//import SearchLabelComponent from "../../../../BasicControls/SearchLabelComponent.vue";  
//import ButtonOutline from "../../../../BasicControls/Buttons/ButtonOutline.vue";

export default {
    name: "VotingSettings",
    components: {
        SmallLoader,
        //SearchLabelComponent,
        //ButtonOutline
    },
    computed:{
    },
    data() {
        return {
            isLoading: false,
           
        }
    },
    async mounted() {
        try {
            this.isLoading = true;
        }
        finally {
            this.isLoading = false;
        }
    },
    watch:{
      
    },
    methods: {
        async updateMenuInteractiveShowQorum() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.menuInteractiveShowQorum = this.$store.state.settings.runtime.menuInteractiveShowQorum;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateInteractiveModalVotingShowAvatar() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.interactiveModalVotingShowAvatar = this.$store.state.settings.runtime.interactiveModalVotingShowAvatar;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateInteractiveModalQuorumShowAvatar() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.interactiveModalQuorumShowAvatar = this.$store.state.settings.runtime.interactiveModalQuorumShowAvatar;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateInteractiveDiscussionShowAvatar() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.interactiveDiscussionShowAvatar = this.$store.state.settings.runtime.interactiveDiscussionShowAvatar;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateClientLogoShowOw() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.clientLogoShowOw = this.$store.state.settings.runtime.clientLogoShowOw;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateClientLogoShowDocuments() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.clientLogoShowDocuments = this.$store.state.settings.runtime.clientLogoShowDocuments;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateClientFooterShowDocuments() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.clientFooterShowDocuments = this.$store.state.settings.runtime.clientFooterShowDocuments;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateShowClockInOw(){
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.showClockInOw = this.$store.state.settings.runtime.showClockInOw;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateUserOnlineBasedOnMicrophones(){
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.userOnlineBasedOnMicrophones = this.$store.state.settings.runtime.userOnlineBasedOnMicrophones;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateSupportCalendarIntegration(){
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.supportCalendarIntegration = this.$store.state.settings.runtime.supportCalendarIntegration;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateDisplayGovernmentNews() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.displayGovernmentNews = this.$store.state.settings.runtime.displayGovernmentNews;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateShowUserAvatarInMultiSelect() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.showUserAvatarInMultiSelect = this.$store.state.settings.runtime.showUserAvatarInMultiSelect;
                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateShowVotingListInOw() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.showVotingListInOw = this.$store.state.settings.runtime.showVotingListInOw;
                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        // OW czyta wyłącznie ustawienia klienta, więc zapisujemy z settings.client, nie z runtime (runtime bywa ustawieniami użytkownika)
        async updateShowNamedVotingResultsInOw() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.client };
                data.showNamedVotingResultsInOw = this.$store.state.settings.client.showNamedVotingResultsInOw;
                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateShowSpeakerAboveAttachment() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.client };
                data.showSpeakerAboveAttachment = this.$store.state.settings.client.showSpeakerAboveAttachment;
                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateHideDefaultFooterInEmail() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.client };
                data.hideDefaultFooterInEmail = this.$store.state.settings.client.hideDefaultFooterInEmail;
                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },

        async updateShowUserAvatarInContacts() {
            try {
                this.isLoading = true;
                let data = { ...this.$store.state.settings.runtime };
                data.showUserAvatarInContacts = this.$store.state.settings.runtime.showUserAvatarInContacts;

                await this._internalUpdateData(data);
            }
            finally {
                this.isLoading = false;
            }
        },
        
        async _internalUpdateData(data) {
            return await settingsService.updateClientSettings(data);
        },

    }
}
</script>
<style lang="scss">
@use "@/assets/scss/user-profile-component.scss";

.in-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.in-row .esesja-modal__row {
    margin-bottom: 0px;
    margin-right: 10px;
}

.esesja-modal__wraper__body__label {
    cursor: pointer;
}

.settings {
    padding: 15px 10px;
}
</style>
